import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './assets/tailwind.css'

if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        navigator.serviceWorker.register('/sw.js').then(registration => {
            console.log('SW registered: ', registration);

            registration.addEventListener('updatefound', () => {
                const newWorker = registration.installing;
                if (!newWorker) return;

                newWorker.addEventListener('statechange', () => {
                    // Se lo stato è installed, e c'è già un controller, significa che è un update non una prima installazione
                    if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                        // Vogliamo mostrare il prompt
                        const event = new CustomEvent('swUpdated', { detail: registration });
                        window.dispatchEvent(event);
                    }
                });
            });

        }).catch(registrationError => {
            console.log('SW registration failed: ', registrationError);
        });

        // Questa ascolta il segnale "skipWaiting" da App.vue -> sw.js -> qui
        let refreshing = false;
        navigator.serviceWorker.addEventListener('controllerchange', () => {
            if (!refreshing) {
                refreshing = true;
                window.location.reload();
            }
        });
    });
}

createApp(App).use(router).mount('#app')
